import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import articlesReducer from "../features/articles/articlesSlice";
import volumesReducer from "../features/volume/volumesSlice";
import authorReducer from "../features/authors/authorSlice";
import reviewReducer from "../features/review/reviewSlice";
import editorReducer from "../features/editor/editorSlice";
import affiliationReducer from "../features/affiliation/affiliationSlice";
import dimensionsReducer from "../features/dimension/dimensionsSlice";
import reminderReducer from "../features/reminder/reminderSlice";
import filesReducer from "../features/files/fileSlice";
import app_languageReducer from "../features/app_language/app_languageSlice";
import messageReducer from "../features/messages/messageSlice";
import adminReducer from "../features/admin/adminSlice";
import magicLinksReducer from "../features/magicLinks/magicLinksSlice";
import orcidReducer from "../features/orcid/orcidSlice"
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const dimensionsPersistConfig = {
  key: "dimensions",
  storage,
};

const adminPersistConfig = {
  key: "admin",
  storage,
  whitelist: ["publicationTheme"],
};

const persistedDimensionsReducer = persistReducer(
  dimensionsPersistConfig,
  dimensionsReducer,
);
const persistedAdminReducer = persistReducer(adminPersistConfig, adminReducer);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    articles: articlesReducer,
    previousArticle: articlesReducer,
    nextArticle: articlesReducer,
    volumes: volumesReducer,
    author: authorReducer,
    review: reviewReducer,
    editor: editorReducer,
    affiliation: affiliationReducer,
    dimensions: persistedDimensionsReducer,
    files: filesReducer,
    app_language: app_languageReducer,
    messages: messageReducer,
    admin: persistedAdminReducer,
    reminder: reminderReducer,
    magicLinks: magicLinksReducer,
    orcid: orcidReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
